import React, { useCallback } from 'react';
import classNames from 'classnames';
import useInput from '../../../../../../../../hooks/useInput';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getTournamentChatUnread } from '../../../../../../../../store/selectors';

const sendSVG = <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="14px" viewBox="0 0 16 14" version="1.1">
      <title>FCB18329-5710-4CEC-9320-2FACB2A21013@1.5x</title>
      <desc>Created with sketchtool.</desc>
      <g id="Casino-Tournaments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Gameplay---menu-chat-keyboard" transform="translate(-339.000000, -412.000000)" fill="#EEEEEE" fill-rule="nonzero">
              <g id="Group-31" transform="translate(8.000000, 207.000000)">
                  <g id="Group-8-Copy-2" transform="translate(0.000000, 191.000000)">
                      <g id="Group-3" transform="translate(320.000000, 4.000000)">
                          <polygon id="Send" points="11.428 23.425 26.303 17.05 11.428 10.675 11.428 15.622 22.053 17.05 11.428 18.478"/>
                      </g>
                  </g>
              </g>
          </g>
      </g>
    </svg>

  const bubbleSVG = <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
  <title>E5852EBD-72AA-414F-BAAE-0BFC314DE01C@1.5x</title>
  <desc>Created with sketchtool.</desc>
  <g id="Casino-Tournaments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Gameplay---menu" transform="translate(-324.000000, -531.000000)" fill="#FFFFFF" fill-rule="nonzero">
          <g id="Group-8" transform="translate(16.000000, 510.000000)">
              <g id="Group-3" transform="translate(296.000000, 0.000000)">
                  <path d="M30.75,37.515625 L29.953125,34.046875 C29.953125,33.859375 30,33.671875 30.09375,33.484375 C30.09375,33.453125 30.109375,33.421875 30.140625,33.390625 L30.1875,33.34375 C31.0625,32 31.5,30.59375 31.5,29.125 C31.5,26.96875 30.703125,25.1171875 29.109375,23.5703125 C27.515625,22.0234375 25.59375,21.25 23.34375,21.25 C21.40625,21.25 19.6875,21.84375 18.1875,23.03125 C16.6875,24.21875 15.75,25.703125 15.375,27.484375 C15.28125,28.015625 15.234375,28.5625 15.234375,29.125 C15.234375,31.28125 16.0234375,33.125 17.6015625,34.65625 C19.1796875,36.1875 21.09375,36.953125 23.34375,36.953125 C24.0625,36.953125 24.75,36.859375 25.40625,36.671875 C25.90625,36.546875 26.28125,36.4375 26.53125,36.34375 L26.625,36.296875 C26.8125,36.234375 26.953125,36.203125 27.046875,36.203125 C27.171875,36.203125 27.328125,36.234375 27.515625,36.296875 L30.75,37.515625 Z M12.75,40.75 L15.375,39.71875 C15.5625,39.65625 15.703125,39.625 15.796875,39.625 C15.921875,39.625 16.046875,39.65625 16.171875,39.71875 L16.21875,39.71875 C17.1875,40.09375 18.09375,40.28125 18.9375,40.28125 C21.125,40.28125 22.921875,39.453125 24.328125,37.796875 C23.671875,37.984375 22.984375,38.078125 22.265625,38.078125 C20.015625,38.078125 18.09375,37.3046875 16.5,35.7578125 C14.90625,34.2109375 14.109375,32.359375 14.109375,30.203125 C14.109375,29.828125 14.171875,29.296875 14.296875,28.609375 C12.765625,29.921875 12,31.578125 12,33.578125 C12,34.890625 12.375,36.09375 13.125,37.1875 L13.125,37.28125 C13.125,37.28125 13.140625,37.296875 13.171875,37.328125 C13.265625,37.484375 13.3125,37.640625 13.3125,37.796875 L12.75,40.75 Z" id="message"/>
              </g>
          </g>
      </g>
  </g>
</svg>

const TournamentChatSend = ({ emitToSocket, tournamentId, dark, changeState, tournamentChatStatus, sendOrOpen }) => {
  const { t } = useTranslation();
  const [message, onMessageChange, setMessage] = useInput('');

  const unreadMessages = useSelector(getTournamentChatUnread);
  const unreadMessagesCount = unreadMessages[tournamentId];

  const sendButton =  () => {
    if(!tournamentChatStatus) {
      changeState();
    }
    else onSendMessage()
  }

  const onSendMessage = useCallback(() => {
    if(!!message.replace(/\s/g,"").length) {
      emitToSocket('sendMessage', { tournamentId, message });
    }
    setMessage('');
  }, [message, tournamentId, emitToSocket]);

  const checkEnter = useCallback(e => {
    if (e.keyCode === 13) onSendMessage();
  }, [onSendMessage]);

  const classes = classNames('tournaments__chat__send', { 'tournaments__chat__send--dark': dark });

  

  const sendButtonIcon = () => {
    if(sendOrOpen) {
      return !tournamentChatStatus ? bubbleSVG : sendSVG;
    }
    return sendSVG;
  }

  return (
    <div className={classes}>
      <input
        className="tournaments__chat__send-input"
        type="text"
        placeholder={t('tournaments.typeYourMessage')}
        onChange={onMessageChange}
        onKeyUp={checkEnter}
        value={message}
      />
      <button className={`tournaments__chat__send-button `}
        onClick={sendOrOpen ? () => sendButton() : onSendMessage}>
        {(!tournamentChatStatus && unreadMessagesCount > 0) && 
          <span className="tournaments__chat__send-button__unread-message">{`${unreadMessagesCount > 90 ? '+90' : unreadMessagesCount}`}</span>
        }
        {sendButtonIcon()}
      </button>
    </div>
  );
}

export default TournamentChatSend;
